import { useQuery } from '@tanstack/react-query';
import { LoneWorkContact, LoneWorkBoard } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../../lib/api';

export const ContactList = z.array(LoneWorkContact);
export { LoneWorkBoard };

export const loneKey = ['lone-working'] as const;
export const boardKey = [...loneKey, 'board'] as const;
export const contactsKey = (memberId: string) => [...loneKey, 'contacts', memberId] as const;

export function useBoard(refetchMs: number) {
  return useQuery({ queryKey: boardKey, queryFn: () => api.get('/lone-working/board', { schema: LoneWorkBoard }), refetchInterval: refetchMs });
}
